module.exports = __webpack_public_path__ + "static/media/book64.2b53754a.png";